import { configureRequest, replacePathVariables } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import {
  GetAirportZipCodeErrorResponse,
  GetAirportZipCodeRequest,
  GetAirportZipCodeSuccessResponse
} from './getAirportZipCode.types'

export const getAirportZipCodeApi = async (
  request: GetAirportZipCodeRequest
): Promise<GetAirportZipCodeSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.flights.getAirportZipCode, { iataCode: request.iataCode }),
    method: 'GET'
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetAirportZipCodeSuccessResponse
  } else {
    throw response as GetAirportZipCodeErrorResponse
  }
}

export default getAirportZipCodeApi
